import React, { PropsWithChildren } from 'react'
import { Modal, ModalProps } from '@mui/material'
import CustomAlert, {
  CustomAlertProps,
  CustomAlertTypes
} from '../customAlert/CustomAlert'

interface Props extends Pick<ModalProps, 'open' | 'onClose'>, CustomAlertProps {
  width?: string
  height?: string
  open: boolean
  type?: CustomAlertTypes
}

const CustomAlertModal: ReactFC<PropsWithChildren<Props>> = React.forwardRef(
  ({ width, height, children, open, onClose, sx, type, ...boxProps }, ref) => {
    return (
      <Modal open={open} onClose={onClose} ref={ref as any}>
        <CustomAlert
          sx={{
            width,
            height,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            outline: 'none',
            ...sx
          }}
          type={type}
          {...boxProps}
        >
          {children}
        </CustomAlert>
      </Modal>
    )
  }
)

CustomAlertModal.displayName = 'CustomModal'
export default CustomAlertModal
